var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('worker-form',{ref:"worker_form_p",attrs:{"source-data":_vm.choose,"org-tree":_vm.orgTree,"fun-auth":{
    edit: false,
    add: false
  },"read-only":_vm.readOnly,"type":_vm.type}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }